<template>
  <ItemsLister v-bind="itemsListerConfig" :itemsListHelpers="liveStreamsListHelpers" />
</template>

<script lang="ts" setup>
import ItemsLister from '@/components/ListingPages/ItemsLister/ItemsLister.vue';
import itemsListerConfig from './config/itemsLister.config';
import { useLiveStreamsListHelpers } from './liveStreamsListHelpers';
const liveStreamsListHelpers = useLiveStreamsListHelpers();
</script>

<style lang="scss" scoped>
</style>